import { useClassNames } from '@magnetic/hooks';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const InputFunctionalButton = /* @__PURE__ */ __name(({
  className,
  ...rest
}) => {
  const classNames = useClassNames(
    "mds-rebuild-input-functional-button",
    className
  );
  return /* @__PURE__ */ React.createElement("button", {
    className: classNames,
    ...rest,
    type: "button"
  });
}, "InputFunctionalButton");
InputFunctionalButton.displayName = "Input.FunctionalButton";

export { InputFunctionalButton };
//# sourceMappingURL=input-functional-button.js.map
